import { MapContainer, TileLayer, CircleMarker, Popup, Tooltip, Marker } from "react-leaflet";
import { useState, useEffect, useCallback, useRef, useMemo } from "react";
import 'leaflet/dist/leaflet.css';
import axios from "axios";
import authHeader from "../../services/auth-header";

import { iconPerson } from "./Icon.js";

const api = require("../../api/names.js");

function DraggableMarker(props) {
    const [draggable, setDraggable] = useState(false)
    const [position, setPosition] = useState({lat: props.lat, lng: props.lon})
    const markerRef = useRef(null)
    const address = props.address;
    const eventHandlers = useMemo(
        () => ({
            dragend() {
                const marker = markerRef.current
                if (marker != null) {
                    setPosition(marker.getLatLng())
                }
            },

        }),
        [],
    )

    useEffect(() => {

    },[position])

    function save(){
        var url = api.baseUrl + '/detectorsGpsLocation/';
        url += address;
        const jsonData = {
            "address": address,
            "gpsLatitude": position.lat,
            "gpsLongtitude": position.lng}
        axios.put(url,jsonData, { headers: authHeader() }); // body data type must match "Content-Type" header
    }

    const toggleDraggable = useCallback(() => {
        setDraggable((d) => !d)
    }, [])

    return (

        <Marker
            draggable={draggable}
            eventHandlers={eventHandlers}
            position={position}
            ref={markerRef}
            icon = {iconPerson}>
            <Popup minWidth={90}>
                <span>
                    Sensor: {address}
                </span><br/>
                <span>
                    Lat: {position.lat}
                </span><br />
                <span>
                    Lng: {position.lng}
                </span><br />
                <span type = "button" onClick={toggleDraggable}>
                    {draggable
                    ? 'Marker is draggable'
                    : 'Marker is not draggable'}
                </span><br/>
                <span type="button" onClick={save}>
                    Save
                </span>
            </Popup>
        </Marker>

    )
}

function EditMap(props) {

    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [items, setItems] = useState([]);

    useEffect(() => {
        var url = api.baseUrl + '/detectorsEUIs/WithGPSByParkingID/';
        url += props.parkingID;
        //console.log(url);
        
        fetch(url, {
      method: 'get',
      headers: authHeader()
      })
            .then(res => res.json())
            .then(
                (result) => {
                    //console.log(result);
                    setIsLoaded(true);
                    setItems(result);
                },
                (error) => {
                    setIsLoaded(true);
                    setError(error);
                }
            )
    },[])

    return (
        <div>

            <MapContainer className="map" center={[props.gpsLatitude, props.gpsLongtitude]} zoom={21} scrollWheelZoom={false}>
                <TileLayer
                    maxZoom={19}
                    attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />


                {items.map((item,index) => (
                    <DraggableMarker key = {index} address={item.address} lat={item.detectorsGpsLocation.gpsLatitude} lon={item.detectorsGpsLocation.gpsLongtitude} parking={props.parkingID} />
                ))}
            </MapContainer>

        </div>
    );
};

export default EditMap;
